
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Building2, Users, MapPin } from 'lucide-react';

const LosAngelesPage = () => {
  return (
    <CityPageTemplate
      city="Los Angeles"
      state="California"
      stateAbbr="CA"
      population="4 million+"
      majorIndustries={["entertainment", "technology", "manufacturing", "healthcare", "international trade"]}
      businessChallenges={[
        "High labor costs and competitive talent market",
        "Complex California employment regulations",
        "Expensive commercial real estate and operations",
        "Managing diverse, multilingual workforce",
        "High workers' compensation rates"
      ]}
      peoSolutions={[
        "Access to enterprise-level benefits at group rates",
        "Expert California employment law compliance",
        "Professional HR support and risk management",
        "Streamlined payroll and tax administration",
        "Workers' compensation cost control"
      ]}
      localBusinessTypes={[
        { name: "Entertainment", description: "Studios, production companies, talent agencies" },
        { name: "Technology", description: "Software, digital media, startups" },
        { name: "Healthcare", description: "Hospitals, clinics, medical practices" },
        { name: "Manufacturing", description: "Aerospace, apparel, food processing" }
      ]}
      metaDescription="Find the best PEOs in Los Angeles with The PEO App. Compare quotes from top LA Professional Employer Organizations offering comprehensive HR, payroll, and benefits solutions for California businesses."
      keyFeatures={[
        {
          icon: Building2,
          title: "Entertainment Industry Expertise",
          description: "Specialized HR solutions for LA's entertainment and media companies with union compliance and project-based staffing."
        },
        {
          icon: Users,
          title: "Diverse Workforce Management",
          description: "Expert support for managing LA's multicultural workforce with multilingual HR services and cultural competency."
        },
        {
          icon: MapPin,
          title: "California Compliance",
          description: "Navigate complex California employment laws including PAGA, meal breaks, and overtime regulations."
        }
      ]}
    />
  );
};

export default LosAngelesPage;
